// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__wB_A1","isHidden":"Footer_isHidden__AZW26","item":"Footer_item__NxtC9","link":"Footer_link__3C5dd","text":"Footer_text__8_9iX"};